import '../sass/style.scss';

function InitializePage($, Drupal, DrupalSettings) {
    $(document).ready(() => {
        if (DrupalSettings?.univ?.menuColumnLimit) DrupalSettings.univ.menuColumnLimit = 12;
        /**
         * Block menu
         */
        const headerContentContainer = $("header .main-header-content .navigation.block-menu > .content");
        function closeHeaderContainer() {
            headerContentContainer.removeClass("mega-menu");
            headerContentContainer.css("height", "auto");
        }

        /**
         *  Custom search block
         */
        const searchBlockForm = $("#views-exposed-form-di-mekletajs-page-1");
        searchBlockForm.hide(0);

        const searchBlockButton = $(".search--btn")
        searchBlockButton.on("click keyup", function (event) {
            // If it is a keypress event, ignore any key but enter and space
            if (event.type === "keyup" && event.which !== 13) return;
            $(this).hide();
            searchBlockForm.animate({
                width: "toggle"
            }, 300);

            $("#edit-keys", searchBlockForm).focus();
        });

        /**
         *  Events
         */
        const months = {
            "lv": ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JŪN', 'JŪL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'],
            "en": ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
        }
        const currentLanguage = DrupalSettings?.path?.currentLanguage ?? 'lv';

        const eventsBlock = $("div.events-block");
        $(".views-row", eventsBlock).each(function() {
            const eventDayField = $(".views-field-field-date-from", this);
            const eventMonthField = $(".views-field-field-date-from-1", this);

            const eventDate = new Date($("time", eventDayField).attr("datetime"));
            const currentDate = new Date();

            if (currentDate > eventDate) {
                eventDayField.addClass("active-event");
            }
            $("time", eventDayField).text(eventDate.getDate())
            $("time", eventMonthField).text(months[currentLanguage][eventDate.getMonth()]);
        });

        /**
         *  Custom mobile header
         */

        const mainHeader = $("#header");
        const mobileHeader = $("#header-mobile");
        // Language selector
        $(".secondaryMenu .language-selector", mainHeader)
            .clone().appendTo("#header-mobile .header-mobile--languages-select");

        // Set lang text next to dropdown
        $(`.header-mobile--languages-select ul li.${currentLanguage} a`, mobileHeader)
            .clone().prependTo("#header-mobile .header-mobile--languages-select").addClass("lang-dropdown");
        const langDropdownText = $("a.lang-dropdown", mobileHeader);
        langDropdownText.text(langDropdownText.text().substring(0, 3));
        langDropdownText.attr("href", "#");

        // Branding
        $(".main-header-content .site-branding", mainHeader)
            .clone().appendTo("#header-mobile .header-mobile--logo");

        // Navigation
        $(".secondaryMenu nav.block-menu .content ul", mainHeader).clone().appendTo("nav#quick-nav-mobile");
        $(".main-header-content nav.block-menu ul.menu.menu-level--0", mainHeader).clone().appendTo("nav#nav-mobile");
        $("nav#nav-mobile ul.menu.menu-level--0>li").has("ul").prepend('<div class="btn-show-submenu"></div>');
        $("nav#nav-mobile ul.menu-level--1 > li").has("ul").prepend('<div class="btn-show-sub-submenu"></div>');
        $(".btn-show-submenu, .btn-show-sub-submenu").on("click", function () {
            const btnSubMenu = $(this).next().next();
            if (btnSubMenu.is(":visible"))
            {
                btnSubMenu.slideUp();
                $(this).removeClass("rotated");
            } else {
                btnSubMenu.slideDown();
                $(this).addClass("rotated");
            }
        });

        // Mobile header animations
        $("a.lang-dropdown").on("click", function () {
            const langSelector = $(".header-mobile--languages-select ul.language-selector");
            langSelector.is(":visible") ? langSelector.slideUp() : langSelector.slideDown()
        });
        $(".header-mobile--menu-btn").on("click", function () {
            $("nav#nav-mobile").slideDown();
            $("#page-wrapper").hide();
        });
        $(".header-mobile--quick-menu-btn").on("click", function () {
            $("nav#quick-nav-mobile").slideDown();
            $("#page-wrapper").hide();
        });
        $(".btn-close-menu").on("click", function () {
            $("#page-wrapper").show();
            $("nav#nav-mobile").slideUp();
            $("nav#quick-nav-mobile").slideUp();
        });
    });
}
InitializePage(jQuery, Drupal, drupalSettings);